import { LayoutGrid, List } from "lucide-react";
import { Button } from "./button";
import { cn } from "@/lib/utils";

interface ViewToggleProps {
  view: "list" | "card";
  onViewChange: (view: "list" | "card") => void;
  className?: string;
}

export function ViewToggle({ view, onViewChange, className }: ViewToggleProps) {
  return (
    <div className={cn("flex gap-1 border rounded-lg p-1", className)}>
      <Button
        variant={view === "list" ? "default" : "ghost"}
        size="sm"
        onClick={() => onViewChange("list")}
        className="gap-2"
      >
        <List className="h-4 w-4" />
        List
      </Button>
      <Button
        variant={view === "card" ? "default" : "ghost"}
        size="sm"
        onClick={() => onViewChange("card")}
        className="gap-2"
      >
        <LayoutGrid className="h-4 w-4" />
        Cards
      </Button>
    </div>
  );
}
